import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { ErrorsRouteName } from '@/types/router/name/errors';
import { ErrorsRoutePath } from '@/types/router/path/errors';

export default [
    {
        path: ErrorsRoutePath.NotFound,
        name: ErrorsRouteName.NotFound,
        component: () => import('@/pages/errors/404.vue'),
        meta: {
            title: 'Page Not Found',
            layout: DefaultLayout
        }
    },
    {
        path: ErrorsRoutePath.ServerError,
        name: ErrorsRouteName.ServerError,
        component: () => import('@/pages/errors/500.vue'),
        meta: {
            title: 'Server Error',
            layout: DefaultLayout
        }
    }
];
